/**
 * Backward Compatibility Configuration
 * This file maintains compatibility with the old global.config pattern
 * while using the new dynamic configuration system
 */
import { getConfigSync, initializeConfig } from './config/index';

// Attempt to get synchronous config or initialize if needed
let config = getConfigSync();

if (!config) {
    console.warn('Configuration not loaded yet, initializing...');
    // Initialize config asynchronously and set up global when ready
    initializeConfig().then((loadedConfig) => {
        config = loadedConfig;
        if (typeof global !== 'undefined') {
            global.config = config;
        }
        if (typeof module !== 'undefined' && module.exports) {
            module.exports = global.config = config;
        }
    }).catch((error) => {
        console.error('Failed to load configuration:', error);
        // Fallback to minimal config
        config = getMinimalConfig();
        if (typeof global !== 'undefined') {
            global.config = config;
        }
    });

    // Return minimal config for immediate use
    config = getMinimalConfig();
}

// Set global config for immediate access
if (typeof global !== 'undefined') {
    global.config = config;
}

// For CommonJS compatibility
if (typeof module !== 'undefined' && module.exports) {
    module.exports = global.config = config;
}

/**
 * Get minimal configuration for fallback
 */
function getMinimalConfig() {
    return {
        api: {
            domain: 'https://sandboxfwapi.evidenceiq.com',
            port: '',
            googleMapsApiKey: 'AIzaSyBYOgqZ4JqRxMjxl6erXprF_JgBgaMvnU0'
        },
        images3: {
            link: 'https://fwiq-sb.s3.us-east-2.amazonaws.com',
        },
        Defines: {
            ImageSize: {
                full: 'full',
                thumb: 'thumb',
                small: 'small',
                medium: 'medium',
                large: 'large',
                extraLarge: 'extra_large',
            },
            GalleryType: {
                catalog: 'catalog',
                evidence: 'evidence',
            },
            CategoryID: {
                NewShoe: 1,
                RecoveredShoe: 2,
                TestShoe: 3
            },
            CategoryName: {
                NewShoe: 'New Shoe',
                RecoveredShoe: 'Recovered Impression',
                TestShoe: 'Test Shoe'
            },
            ImportStatus:
            {
                Unknown : -1,
                Pending : 0,
                HasInformation : 1,
                HasOriginalImages : 2,
                Standardizing : 3,
                HasStandardizedImages : 4,
                HasVector : 8,
            },
            ImageType: {
                SHOE_SOLE: 1,
                SHOE_SOLE_LEFT: 101,
                SHOE_SOLE_RIGHT: 102,
                SHOE_SOLE_UNDETERMINED: 103,
                SHOE_PRINT: 2,
                SHOE_PRINT_LEFT: 201,
                SHOE_PRINT_RIGHT: 202,
                SHOE_PRINT_UNDETERMINED: 203,
                SHOE_OTHER: 3,
            },
            ImageTypeKey: {
                SHOE_SOLE: 'Sole',
                SHOE_SOLE_LEFT: 'SoleLeft',
                SHOE_SOLE_RIGHT: 'SoleRight',
                SHOE_SOLE_UNDETERMINED: 'SoleUndetermine',
                SHOE_PRINT: 'Print',
                SHOE_PRINT_LEFT: 'PrintLeft',
                SHOE_PRINT_RIGHT: 'PrintRight',
                SHOE_PRINT_UNDETERMINED: 'PrintUndetermine',
                SHOE_OTHER: 'Other',
            },
            ImageTypeName: {
                SHOE_SOLE: 'Shoe Sole',
                SHOE_SOLE_LEFT: 'Sole Left',
                SHOE_SOLE_RIGHT: 'Sole Right',
                SHOE_SOLE_UNDETERMINED: 'Sole Undetermined',
                SHOE_PRINT: 'Shoe Print',
                SHOE_PRINT_LEFT: 'Print Left',
                SHOE_PRINT_RIGHT: 'Print Right',
                SHOE_PRINT_UNDETERMINED: 'Print Undetermined',
                SHOE_OTHER: 'Other',
            },
        }
    };
}